import { CircularProgress, Collapse, IconButton, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';
import { useData, useStatePtr } from "@pure-ptr/react";
import React, { useContext,useState } from 'react';
import { getServiceLineTrendsSummary } from "../../store/api/summaryDashboard";
import { asDollarsWithZero } from '../../util/format';
import { DashboardFiltersContext, useStyles } from './Dashboard';
import { useDispatch } from 'react-redux';
import { setMulti } from '../../store/actions/pages';
import { nonPaginatedSorting } from '../../util';
import WidgetsSortingComponent from './WidgetsSortingComponent';

export const ServiceLineVarianceTrends = () => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const { dateRange, history } = useContext(DashboardFiltersContext);

    const { data, isPending } = useData( async () => {
        const result = await getServiceLineTrendsSummary(dateRange.startdate, dateRange.enddate);
        return result;
    }, [ dateRange ]);
    const [sortConfig, setSortConfig] = useState({ key: 'contractName', direction: 'asc' }); 

    const sortableColumns = [
        { key: 'contractName', label: 'Contract' },
        { key: 'pxCode', label: 'Procedure Code' },
        { key: 'variance', label: 'Variance' },
        { key: 'totalLineItems', label: 'Count' },
        { key: 'totalAmount', label: 'Total Amount' },


    ];

    const handleServiceLineAmountClick = (contractName, pxCode = null, variance = null) => {
        let filters = [
            {
                actualFilter: true, 
                equator: "equals", 
                field: "contractName", 
                value: contractName
            }
        ];

        if(variance != null) {
            filters.push({
                actualFilter: true, 
                equator: "equals", 
                field: "variance", 
                value: variance
            });
        }
        else {
            filters.push({
                actualFilter: true, 
                equator: "greater_than", 
                field: "variance", 
                value: 0
            });
        }

        if(pxCode != null) {
            filters.push({
                actualFilter: true, 
                equator: "equals", 
                field: "pxCode", 
                value: pxCode
            });
        }

        dispatch( setMulti('charge-analysis-landing', {
            filter: filters,
            selectedFilter: null,
            customFilter: [
                {
                    customFilter: true, 
                    equator: "greater_than_or_equals_to", 
                    field: "remitdate", 
                    value: dateRange.startdate,
                    relativeFilter:dateRange.relativeFilter
                },
                {
                    customFilter: true, 
                    equator: "less_than_or_equals_to", 
                    field: "remitdate", 
                    value: dateRange.enddate,
                    relativeFilter:dateRange.relativeFilter
                },
                {
                    customFilter: true, 
                    equator: "equals", 
                    field: "isPaid", 
                    value: true
                },
                {
                    customFilter: true, 
                    equator: "equals", 
                    field: "isDenial", 
                    value: false
                },
                {
                    customFilter: true, 
                    equator: "equals", 
                    field: "acknowledged", 
                    value: false
                }
            ],
            list: [],
            significance: false,
            searchTerm:"",
        }));

        history.push("/cms/charge-analysis/fromSummary");
    }

    const sortedData = React.useMemo(
        () =>
            nonPaginatedSorting([sortConfig], [...(data || [])])
                ?.tableData,
        [data, sortConfig]
    );

    return isPending ? (
        <CircularProgress />
    ) : (
        <Table stickyHeader>
            <TableHead>
                <TableRow>
                    <WidgetsSortingComponent sortableColumns={sortableColumns} sortConfig={sortConfig} setSortConfig={setSortConfig}/>
                </TableRow>
            </TableHead>
            <TableBody>
            {sortedData?.map((claim, index) => (
                <TableRow key={`${claim.contractName}-${claim.pxCode}-${index}`}>
                    <TableCell>{claim.contractName}</TableCell>
                    <TableCell>{claim.pxCode}</TableCell>
                    <TableCell>{asDollarsWithZero(claim.variance)}</TableCell>
                    <TableCell>{claim.totalLineItems ?? 0}</TableCell>
                    <TableCell>
                    <Typography
                        onClick={() => handleServiceLineAmountClick(claim.contractName, claim.pxCode, claim.variance)}
                        variant="body2"
                        className={classes.link}
                    >
                        {asDollarsWithZero(claim.totalAmount)}
                    </Typography>
                    </TableCell>
                </TableRow>
            ))}
            </TableBody>
        </Table>
    );
}